import React from 'react';
import SvgIcon from './SvgIcon';

const Light = props => (
    <SvgIcon viewBox="0 0 26 26" {...props}>
        <path
            d="M13 1l2.985 4.794 5.5-1.28-1.279 5.501L25 13l-4.794 2.985 1.28 5.5-5.501-1.279L13 25l-2.985-4.794-5.5 1.28 1.279-5.501L1 13l4.794-2.985-1.28-5.5 5.501 1.279L13 1z"
            stroke="currentColor"
        />
        <circle cx={13} cy={13} r={5} stroke="currentColor" />
    </SvgIcon>
);

Light.displayName = 'LightIcon';

export default Light;
